import BaseForm from './base';
export class RawJSONForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            {
                label: 'Raw JSON Editor',
                editor: 'ace',
                autoExpand: false,
                spellcheck: true,
                tableView: true,
                inputFormat: 'plain',
                // customDefaultValue: "value = submission.data.model;",
                // calculateValue: "value = submission.data.container",
                calculateServer: false,
                allowCalculateOverride: true,
                key: 'model',
                type: 'textarea',
                as: 'json',
                input: true,
                wysiwyg: {
                    mode: 'json',
                    highlightGutterLine: true,
                    // theme: 'ace/theme/solarized_dark',
                    // displayIndentGuides: true,
                    maxLines: 50,
                    enableBasicAutocompletion: true,
                    enableSnippets: true,
                    enableLiveAutocompletion: true
                },
                validate: {
                    custom: "valid = (typeof input === 'object') ? true : 'Invalid JSON';"
                },
            }
        ];
    }
}
